// Constants
import { GridViewName } from "@ms/uno-constants/lib/local/TaskGridConstants";
// Models
import { TaskAccessContext } from "../client/legacyPlanner/task/TaskAccessContext";
// Utilities
import { memoizeFunction } from "@fluentui/utilities";
/**
 * Get the TaskAccessContext from the view key
 * viewKey is in format: taskAccessContext_viewPartitionKey OR componentName_viewPartitionKey
 * @param viewKey view key
 */ export const getTaskAccessContextFromViewKey = memoizeFunction((viewKey)=>{
    const viewKeyParts = viewKey.split("_");
    if (viewKeyParts.length < 2) {
        return null;
    }
    // Case 1: viewKey in format taskAccessContext_viewPartitionKey
    if (viewKeyParts[0].length === 1) {
        const taskAccessContextKey = parseInt(viewKeyParts[0], 10);
        if (taskAccessContextKey in TaskAccessContext) {
            const taskAccessContext = taskAccessContextKey;
            return taskAccessContext;
        }
    }
    // Case 2: viewKey in format componentName_viewPartitionKey
    const componentName = viewKeyParts[0];
    switch(componentName){
        case GridViewName.MyDayGridView:
            return TaskAccessContext.MyDay;
        case GridViewName.AllUserTasksGridView:
        case GridViewName.AssignedToUserGridView:
        case GridViewName.MyTasksBasicPlanTasksGridView:
            return TaskAccessContext.AssignedToUser;
        case GridViewName.BasicPlanTasksGridView:
            return TaskAccessContext.Plan;
        default:
            return null;
    }
});
